<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Заказ создан
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <div class="os-history-item__source">
        <div class="os-history-item__source_icon">
          <img v-if="item.deviceType ==='web'" src="img/icons/order-history/web.svg">
          <img v-if="item.deviceType ==='crm'" src="img/icons/order-history/crm.svg">
          <img v-if="item.deviceType ==='mobile'" src="img/icons/order-history/mobile.svg">
        </div>

        <div>
          <div class="os-history-item__source_desc">
            Источник:
          </div>
          <div class="os-history-item__source__name">
            {{ orderSource }}
          </div>
        </div>
      </div>

      <user-info-label :user="item.user"/>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar'
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import { mapState } from 'vuex'

  export default {
    name: 'HistoryItemTypeCreate',
    components: { UserInfoLabel, Avatar },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    data () {
      return {

      }
    },
    computed: {
      ...mapState({
        // order: state => state.fastOrder,
        basket: state => state.baskets.basket,
      }),
      orderSource () {
        if (this.basket.isAggregator) {
          return this.basket.basketSourceDescription
        }

        switch (this.item.deviceType) {
          case 'web':
            return 'Через сайт'

          case 'crm':
            return 'FAKT'

          case 'mobile':
            return 'Моб. приложение'

          case 'aggregator':
            return 'Агрегатор'
        }

        return 'Источник не определен'
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
